import React from 'react';
import styles from './styles.module.scss';

import { ReactComponent as Arrow } from '../../../assets/icons/icon-arrow-left.svg';
import LinkLang from '../../Wraps/LinkLang';

const Breadcrumb = ({ step, title, link }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <div className={styles.header}>
        {step !== 1 ? <Arrow /> : ''}
        <LinkLang to={`/checkout/${link}`}>{title}</LinkLang>
      </div>
      <div className={styles.indicators}>
        <span className={styles.indicatorOn} />
        <span
          className={
            step === 2 || step === 3 ? styles.indicatorOn : styles.indicatorOff
          }
        />
        <span
          className={step === 3 ? styles.indicatorOn : styles.indicatorOff}
        />
      </div>
    </div>
  </div>
);
export default Breadcrumb;
